
import TaskMatrix from "@/components/TaskMatrix";

const Index = () => {
  return <TaskMatrix />;
};

export default Index;
